import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent } from '@shared/components/icon/icon.component';
import { Icon } from '@shared/components/icon/icon.enum';
import { ValidatorType } from '@shared/models/enums/validator-type.enum';
import { Question } from '@shared/models/views-models/question-view';
import { SafeHtmlPipe } from '@shared/pipes/safe-html.pipe';
import { StripHtmlPipe } from '../../../../shared/pipes/strip-html.pipe';

@Component({
  selector: 'app-validator',
  standalone: true,
  imports: [TranslateModule, CommonModule, StripHtmlPipe, SafeHtmlPipe, IconComponent],
  templateUrl: './validator.component.html',
  styleUrl: './validator.component.scss',
})
export class ValidatorComponent {
  @Input() question?: Question;
  @Input({ required: true }) validator!: ValidatorType;
  @Input() control?: any;
  @Input() multiMatrixQuestionTitle: string = '';
  Icon = Icon;

  get alternativeTitle(): string | undefined {
    const alternativeId = this.control?.errors?.['QuotaError']?.alternativeId;
    if (!alternativeId || !this.question) {
      return undefined;
    }
    const alternatives = (this.question as any)?.alternatives;
    if (alternatives) {
      const alternative = alternatives.find(
        (alt: any) => alt.id === alternativeId,
      );
      return alternative?.title;
    }

    return undefined;
  }
}
